import { DataFetchingClientProvider } from 'data-fetching-client';
import { client } from '../clients/DataFetchingClient';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProvideDataFetchingClient({
  children
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: children
  });
}
ProvideDataFetchingClient.displayName = 'ProvideDataFetchingClient';